export default "__VITE_ASSET__dd5f1fc7__"